import React from 'react';
import { Loader2 } from 'lucide-react';
import { Skeleton } from './skeleton';
import { cn } from "@/lib/utils";

/**
 * Shared loading state for consistent UX.
 * Use 'spinner' for quick feedback, 'skeleton' for content-placeholder loading.
 */
const LoadingState = ({
  message = 'Loading...',
  variant = 'spinner', // 'spinner' | 'skeleton' | 'minimal'
  className,
}) => {
  if (variant === 'minimal') {
    return (
      <div className={cn('flex items-center justify-center py-12', className)}>
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (variant === 'skeleton') {
    return (
      <div className={cn('space-y-4 py-8', className)}>
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex min-h-[200px] flex-col items-center justify-center gap-4',
        className
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary/60" />
      <p className="font-serif text-lg text-muted-foreground">{message}</p>
    </div>
  );
};

export { LoadingState };
